<script setup lang="ts">
import { useAllStores } from '@/store'

const { t, route } = useAllStores()
const organization_id = route.params.organization_id
</script>

<i18n lang="yaml">
en:
  common: Common
  members: Members
  billing: Billing
ru:
  common: Общие
  members: Участники
  billing: Оплата
</i18n>

<template>
  <div class="row">
    <div class="col">
      <ul class="nav nav-pills flex-column" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <router-link
            :to="{ name: 'organizations:edit', params: { organization_id } }"
            class="nav-link"
            type="button"
            >{{ t('common') }}</router-link
          >
        </li>

        <li class="nav-item" role="presentation">
          <router-link
            :to="{ name: 'organizations:members', params: { organization_id } }"
            class="nav-link"
            type="button"
            >{{ t('members') }}</router-link
          >
        </li>

        <li class="nav-item" role="presentation">
          <router-link
            :to="{ name: 'organizations:billing', params: { organization_id } }"
            class="nav-link"
            type="button"
            >{{ t('billing') }}</router-link
          >
        </li>
      </ul>
    </div>

    <div class="col-10">
      <div class="tab-content">
        <router-view />
      </div>
    </div>
  </div>
</template>
